module.exports = "/assets/29b97f7d356170b8a57ca82c85273fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/supplier/assets/logos/travelcube.png
// module id = 609
// module chunks = 0